import React, {useState, useEffect} from "react";
import TeamDataColumn from "./TeamDataColumn";
import { useParams, Link } from 'react-router-dom';
import HviChart from "../Dashboard/HviChart";
import { getUserData } from "../../redux/actions/userdata";
import { useDispatch, useSelector } from "react-redux";
import { getExpiry } from '../../common';
import { useCookies } from "react-cookie";
import configVars from "../../config";
import { getWithExpiry, setWithExpiry } from '../../common';
import jwtDecode from "jwt-decode";
import { useTranslation } from "react-i18next";
import OrgOviSummary from "./OrgOviSummary";

const OrganizationSummary = (props) => {

    const { organization_id, method } = useParams();
    const [cookies] = useCookies(["sustainyou_user_jwt"]);
    const [translation] = useTranslation("translations");

    const dispatch = useDispatch();
    const userData = useSelector((state) => state.userdata.allUserData);

    const [activeColumn, setActiveColumn] = useState('hvi');
    const [loading, setLoading] = useState(false);
    const [companyHviData, setCompanyHviData] = useState([]);
    const [canUserEdit, setCanUserEdit] = useState(false);
    const [dataFetched, setDataFetch] = useState(false);

    const hvidata = useSelector((state) => state.hvidata.hvidata);

    useEffect(() => {

        let expired = getExpiry("user_data_expire");

        const getAllUserData = async (token) => {
            setLoading(true);
            await dispatch(getUserData(token));
            setLoading(false)
        }

        if (cookies.sustainyou_user_jwt) {
            
            if (expired) {
                getAllUserData(cookies.sustainyou_user_jwt);
            }
        }

        const orgHviData = getWithExpiry( `sy_org_${organization_id}_hvi_data` );

        if ( orgHviData ) {
            setCompanyHviData(  orgHviData );
            setDataFetch(true);
        }


    }, [dispatch, cookies, organization_id, method]);

    useEffect(() => {

        if ( !cookies.sustainyou_user_jwt ) return;

        const decoded = jwtDecode( cookies.sustainyou_user_jwt );

        if ( decoded && props?.owner && props?.managers ) {

            const userID = parseInt( decoded?.id, 10 );
            const ownerID = parseInt( props?.owner?.id, 10 );
            let isManager = false;
            let isOwner = false;
            let isAdmin = false;

            if (props?.managers.some(e => e.id === userID)) {
                isManager = true;
            }

            if ( ownerID === userID ) {
                isOwner = true;
            }

            if ( userData?.roles ) {
                isAdmin = Object.values(userData?.roles).includes("administrator");
            }

            if ( isManager || isOwner || isAdmin ) {
                setCanUserEdit(true);
                setWithExpiry( 'can_user_edit', true );
            }

        } else {
            return;
        }

    }, [cookies.sustainyou_user_jwt, props, userData ]);

    useEffect(() => {

        const mainTabs = ['hvi', 'ovi', 'admin'];

        if ( method && mainTabs.includes( method ) ) {
            setActiveColumn( method );
        }

    }, [method]);

    const handleCompanyHvi = async () => {

        setLoading( true );

        let userRequestData = new FormData();
        userRequestData.append( 'token', cookies.sustainyou_user_jwt );
        userRequestData.append( 'company_id', organization_id );

        const fetchUrl = `${configVars.apiUrl}sustainteams/v1/sustaingetcompanyhvi/`;

        try{

            const response = await fetch(
                fetchUrl,
                {
                method: "POST",
                headers: {
                    Authorization: `Basic ${configVars.auth}`,
                },
                body: userRequestData
                }
            );
            
            const companyResponse = await response.json();
    
            if ( companyResponse ) {

                //console.log( companyResponse );

                if ( companyResponse?.data?.company_result && companyResponse?.data?.company_result?.length > 0 ) {

                    let companyHvi = [];

                    companyResponse.data.company_result.map( (item) => {
                        let itemHvi = null;

                        if (item.hvi && item.hvi.length > 0 ) {
                            
                            itemHvi = JSON.parse( item.hvi );
                            const recentHvi = [...itemHvi].pop();

                            itemHvi = itemHvi.reverse().filter((value, index, self) =>
                                index === self.findIndex((t) => (
                                    t.date === value.date
                                ))
                            )
                            
                            companyHvi.push({
                                user_id: parseInt( item.user_id, 10 ),
                                member_hvi_all: itemHvi,
                                member_hvi: recentHvi
                            });
                        }

                        return itemHvi;
                    })

                    const orgHviData = {
                        members_count: companyResponse?.data?.company_result?.length,
                        organization: companyHvi,
                        personal: []
                    }

                    setCompanyHviData(orgHviData);

                    setWithExpiry( `sy_org_${organization_id}_hvi_data`, orgHviData );
                    setDataFetch(true);

                }

            }

        } catch( error ) {
            console.log( error );
            return error;
        }

        setLoading( false );

    }

    return (
        <div className="summary-wrap mt-5 pb-5 pb-lg-6">

            <div className="row">

                <div className="col-12">

                    <div className="row">
                        <Link to={`/organizations/${organization_id}/hvi/`} className={`col-12 col-lg-4 mb-4 text-decoration-none text-reset team-column-wrap position-relative ${ activeColumn === 'hvi' ? 'active' : ''}`} onClick={() => setActiveColumn('hvi')}>
                            <TeamDataColumn
                                title="HWI"
                                subTitle="Human Well-being Index"
                                icon="smile-o"
                                isSelected={activeColumn === 'hvi' ? true : false}
                                hviArray={hvidata[`org_${organization_id}`]}
                            />
                        </Link>
                        {userData?.all_capabilities && userData?.all_capabilities.includes('owi') &&
                            <Link to={`/organizations/${organization_id}/ovi/`} className={`col-12 col-lg-4 mb-4 text-decoration-none text-reset team-column-wrap position-relative ${ activeColumn === 'ovi' ? 'active' : ''}`} onClick={() => setActiveColumn('ovi')}>
                                <TeamDataColumn
                                    title="OWI"
                                    subTitle="Organisation Well function Index"
                                    icon="users"
                                    isSelected={activeColumn === 'ovi' ? true : false}
                                />
                            </Link>
                        }
                        
                        <Link to={`/organizations/${organization_id}/admin/`} className={`col-12 col-lg-4 mb-4 text-decoration-none text-reset team-column-wrap position-relative ${ activeColumn === 'admin' ? 'active' : ''}`} onClick={() => setActiveColumn('admin')}>
                            <TeamDataColumn
                                title="Inställningar"
                                subTitle="hantera organisation och användare"
                                icon="cogs"
                                isSelected={activeColumn === 'admin' ? true : false}
                            />
                        </Link>
                    </div>

                    {activeColumn === 'hvi' &&
                        <div className="row">
                            <div className={`col-12 d-flex flex-column flex-lg-row align-items-center ${companyHviData && companyHviData?.length > 0 ? '' : 'justify-content-end'}`}>

                                {(!companyHviData || companyHviData?.length === 0) &&
                                    <h4 className="flex-grow-1 text-center text-lg-start mb-3 mb-lg-1">{translation("process_latest_des")}</h4>
                                }

                                <button type="button" className="btn btn-halite-blue rounded-pill" onClick={() => handleCompanyHvi()}>
                                    {loading &&
                                        <div className="spinner-border spinner-border-sm text-light" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    }
                                    {!loading &&
                                        <i className="fa fa-database" aria-hidden="true"></i>
                                    }
                                    <span className="ps-3">{translation("process_latest_btn")}</span>
                                </button>
                            </div>
                        </div>
                    }

                    {activeColumn === 'hvi' &&
                        <HviChart hvi={companyHviData} loading={loading} organization={ organization_id } roles={userData?.roles} gtg={false} dataFetched={dataFetched} />
                    }

                    {activeColumn === 'ovi' && userData?.all_capabilities && userData?.all_capabilities.includes('owi') &&
                        <OrgOviSummary roles={userData?.roles} />
                    }

                </div>

                {activeColumn === 'admin' &&
                    <div className="row">

                            { props?.owner &&
                                <div className="col-12 col-md-6 col-lg-3">
                                    <div className="team-members-wrap h-100 bg-white shadow-sm pt-3 pb-5 px-4 d-flex flex-column justify-content-center border rounded-3 mb-4">
                                        <div className="d-flex align-items-center flex-column">
                                            <h4>{translation("org_owner_text")}</h4>

                                            <div className="team-members d-flex mt-3 flex-column justify-content-center align-items-center">
                                                <div>
                                                    <img src={props?.owner?.avatar} className="rounded-circle" alt="owner-thumb" />
                                                </div>
                                                <h5 className="mt-3">{props?.owner?.name}</h5>
                                            </div>
                                        </div>

                                        {canUserEdit &&
                                            <Link to={`/organizations/${organization_id}/owner/`} className="btn btn-primary text-white mt-3 rounded-pill" >
                                                <span className="pe-2">Byt ägare</span>
                                                <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
                                            </Link>
                                        }
                                    </div>
                                </div>
                                
                            }

                            {props?.managers && props?.managers.length > 0 &&
                                <div className="col-12 col-md-6 col-lg-3">
                                    <div className="team-members-wrap h-100 bg-white shadow-sm pt-3 pb-5 px-4 d-flex flex-column justify-content-center border rounded-3 mb-4">
                                                
                                        <div className="d-flex align-items-center flex-column">
                                            <h4>{translation("managers_text")}</h4>
    
                                            <div className="team-members d-flex mt-2 align-items-center mb-4">
    
                                                { props?.managers.slice(0, 5).map((manager, index) => {
                                                    return(
                                                        <div className="rounded-circle" key={index} 
                                                            style={{ 
                                                                width: "35px",
                                                                height: "35px",
                                                                backgroundImage: `url(${manager?.avatar})`,
                                                                backgroundSize: "cover"
                                                            }}
                                                        >
    
                                                        </div>
                                                    )
                                                })}
    
                                                {props?.managers.length > 5 &&
                                                    <span className="text-primary font-size-medium ms-1">+{props?.managers.length - 5} mer</span>
                                                }
    
                                            </div>
                                        </div>
    
                                        <Link to={`/organizations/${organization_id}/managers/`} className="btn btn-halite-blue mb-2 rounded-pill" >
                                            <span className="pe-2">{translation("view_managers_text")}</span>
                                            <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
                                        </Link>
                                        {canUserEdit &&
                                            <Link to={`/organizations/${organization_id}/managers/edit`} className="btn btn-halite-blue mb-2 rounded-pill" >
                                                <span className="pe-2">Redigera chefer</span>
                                                <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
                                            </Link>
                                        }
    
                                    </div>
                                </div>
                                
                            }

                            {props?.members && props?.members.length > 0 &&
                                <div className="col-12 col-md-6 col-lg-3">
                                    <div className="team-members-wrap h-100 bg-white shadow-sm pt-3 pb-5 px-4 d-flex flex-column justify-content-center border rounded-3">
                                                
                                        <div className="d-flex align-items-center flex-column">
                                            <h4>{translation("members_text")}</h4>
    
                                            <div className="team-members d-flex mt-2 align-items-center mb-4">
    
                                                { props?.members.slice(0, 5).map((member, index) => {
                                                    return(
                                                        <div className="rounded-circle" key={index} 
                                                            style={{ 
                                                                width: "35px",
                                                                height: "35px",
                                                                backgroundImage: `url(${member?.avatar})`,
                                                                backgroundSize: "cover"
                                                            }}
                                                        >
    
                                                        </div>
                                                    )
                                                })}
    
                                                {props?.members.length > 5 &&
                                                    <span className="text-primary font-size-medium ms-1">+{props?.membersCount - 5} mer</span>
                                                }
    
                                            </div>
                                        </div>
    
                                        <Link to={`/organizations/${organization_id}/members/`} className="btn btn-primary text-white mb-2 rounded-pill" >
                                            <span className="pe-2">{translation("view_members")}</span>
                                            <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
                                        </Link>
    
                                        {canUserEdit &&
                                            <Link to={`/organizations/${organization_id}/new-member/`} className="btn btn-halite-blue text-white mb-2 rounded-pill" >
                                                <span className="pe-2">{translation("add_new_member")}</span>
                                                <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
                                            </Link>
                                        }
    
                                    </div>
                                </div>
                                
                            }

                            <div className="col-12 col-md-6 col-lg-3">
                                <div className="team-members-wrap h-100 bg-white shadow-sm pt-3 pb-5 px-4 d-flex flex-column justify-content-center border rounded-3">
                                    <div className="d-flex align-items-center flex-column mb-4">
                                        <h4>{translation("teams_text")}</h4>
                                    </div>

                                    { props?.teams && props?.teams.length > 0 &&
                                        <div className="sub-teams mb-4">
                                            <ol className="mb-0">
                                            { props?.teams.slice(0, 3).map( (team, index) => {
                                                return(
                                                    <li key={index} className="pb-2">
                                                        <Link to={`/organizations/${organization_id}/teams/${team?.ID}`} className="">{team?.team_name}</Link>
                                                    </li>
                                                )
                                            })}
                                            </ol>

                                            { props?.teams.length > 3 &&
                                                <span className="ps-3">{`+${ props?.teams.length - 3 } mer teams`}</span>
                                            }

                                        </div>
                                    }

                                    { props?.teams.length > 3 &&
                                        <Link to={`/organizations/${organization_id}/teams`} className="btn btn-halite-blue mb-2 rounded-pill" >
                                            <span className="pe-2">{translation("view_all")} teams</span>
                                            <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
                                        </Link>
                                    }

                                    {canUserEdit &&
                                        <Link to={`/organizations/${organization_id}/new-team`} className="btn btn-halite-blue mb-2 rounded-pill" >
                                            <span className="pe-2">{translation("add_new_team")}</span>
                                            <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
                                        </Link>
                                    }

                                </div>
                            </div>
                            
                    </div>
                }

            </div>

        </div>
    );

}

export default OrganizationSummary;